import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import axios from "@/axios";

Vue.use(Vuex);

// axios.defaults.baseURL = "https://hr.mediusware.xyz/api";

export default new Vuex.Store({
  state: {
    token: "",
    activeUser: "",
    banners: {},
    testimonials: [],
    coreValues: [],
    gallaries: [],
    location: [],
    awards: [],
  },
  plugins: [createPersistedState()],
  mutations: {
    UPDATE_USER(state, payload) {
      state.activeUser = payload;
    },
    SET_TOKEN(state, payload) {
      state.token = payload;
    },
    SET_BANNERS(state, banners) {
      state.banners = banners;
    },
    SET_TESTIMONIALS(state, testimonials) {
      state.testimonials = testimonials;
    },
    SET_COREVALUES(state, coreValues) {
      state.coreValues = coreValues;
    },
    SET_GALLARY(state, gallaries) {
      state.gallaries = gallaries;
    },
    SET_LOCATION(state, location) {
      state.location = location;
    },
    SET_AWARDS(state, awards) {
      state.awards = awards;
    },
  },
  actions: {
    async fetchActiveUser({ commit, state }) {
      const token = state.token || localStorage.getItem("_token");
      if (!token) {
        console.warn("No token found — skipping user fetch.");
        commit("UPDATE_USER", "");
        return null;
      }

      try {
        const res = await axios.get("/candidate/", {
          headers: { Authorization: `Bearer ${token}` },
        });
        commit("UPDATE_USER", res.data);
        return res.data;
      } catch (err) {
        const status = err.response?.status;
        console.warn(
          "User fetch failed:",
          status,
          err?.response?.data || err.message
        );
        if (status === 401) {
          commit("UPDATE_USER", "");
          commit("SET_TOKEN", "");
          localStorage.removeItem("_token");
        }
        return null;
      }
    },

    // New Action for fetching banners
    fetchBanners(context) {
      axios
        .get("website/website-title/")
        .then((res) => {
          context.commit("SET_BANNERS", res.data); // Commit the data to the state
          //   console.log("Banners Data:", res.data);
        })
        .catch((err) => {
          console.error("Failed to fetch banners:", err);
        });
    },
    fetchCoreValues(context) {
      axios
        .get("website/benefits/")
        .then((res) => {
          // console.log("Outdoor Data Full Response:", res);
          context.commit("SET_COREVALUES", res.data);
        })
        .catch((err) => {
          console.error("Failed to fetch outdoor data:", err);
        });
    },

    // New Action for fetching banners
    fetchEmployeeTestimonial(context) {
      axios
        .get("/website/employee-testimonial/")
        .then((res) => {
          context.commit("SET_TESTIMONIALS", res.data); // Commit the data to the state
          // console.log("Testimonial data ....................... :", res);
        })
        .catch((err) => {
          console.error("Failed to fetch banners:", err);
        });
    },
    // New Action for fetching banners
    fetchOurGallary({ commit, state }) {
      axios
        .get("/website/life-at-mediusware/")
        .then((res) => {
          commit("SET_GALLARY", res.data.results); // Commit the gallery results to the mutation
          console.log("Gallery data fetched:", res.data.results);
        })
        .catch((err) => {
          // console.error("Failed to fetch gallery images:", err);
        });
    },
    fetchOurLocation({ commit, state }) {
      axios
        .get("/website/office-location/")
        .then((res) => {
          commit("SET_LOCATION", res); // Commit the gallery results to the mutation
          console.log("Location data fetched:", res);
        })
        .catch((err) => {
          console.error("Failed to fetch LOCATION :", err);
        });
    },
    fetchAwards({ commit, state }) {
      axios
        .get("/website/awards/")
        .then((res) => {
          commit("SET_AWARDS", res.data.results);
          // console.log("Gallery data fetched:", res.data);
        })
        .catch((err) => {
          console.error("Failed to fetch awards :", err);
        });
    },

    clearState(context) {
      context.commit("SET_TOKEN", "");
      context.commit("UPDATE_USER", "");
    },
  },
});
